<template>
  <div class="main">
    <ActorAvatar v-if="actor && actor.url && !hideImage" :actor="actor" :actor-logo-url="actor.url" :width="50" style="justify-self: center; align-self: center;"/>
    <div @click="addActor">
      <div class="header">
        <div class="title">
          {{ name }}
        </div>
      </div>
      <div class="actor-block__description" v-if="description">{{ description }}</div>
    </div>
    <div class="buttons" v-if="allowInput">
      <ds-button v-if="mode === 'remove'" variant="rounded" icon="trash" :disabled="disabled" @click="denyActorRecommendation" class="actor-button__no-outline"/>
    </div>
  </div>
</template>

<script>
  import { toDateString } from '../../../util/date'
  import { getClearbitActorLogo } from '@/util/actor'
  import ActorAvatar from '@/Domain/Actor/Components/ActorAvatar.vue'

  export default {
    name: 'ActorBlock',
    components: { ActorAvatar },
    data () {
      return {
        showImage: true,
      }
    },
    props: {
      mode: {
        type: String,
        validator: val => ['add', 'remove'].includes(val),
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      id: String,
      name: String,
      description: String,
      url: String,
      allowInput: Boolean,
      actor: Object,
      hideImage: {
        type: Boolean,
        default: false,
      }
    },
    methods: {
      getClearbitActorLogo,
      toDateString,
      addActor () {
        this.$emit('add', this.id)
      },
      denyActorRecommendation () {
        this.$emit('remove', this.id)
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import "../../../../scss/_variables.scss";

  .main {
    display: flex;
    margin-bottom: 20px;
  }

  .actor-button__no-outline.button {
    &:focus {
      box-shadow: none !important;
    }
  }

  .header {
    display: flex;
    cursor: pointer;

    .title {
      font-weight: bold;
      margin-right: auto;
    }

    .date {
      margin-left: 20px;
      color: $color-text-grey-light;
      white-space: nowrap;
    }

    .url {
      white-space: nowrap;
    }
  }

  .actor-block__description {
    margin-top: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    line-height: 14px;
    max-height: 56px;
  }

  .default-image {
    background-image: url("/images/datascouts-logo.svg");
    background-size: cover;
  }

  .buttons {
    display: flex;
    align-items: center;
  }
</style>
